// extracted by mini-css-extract-plugin
export default {"root":"classes_root__bvQUH","left-side":"classes_left-side__UAxq-","right-side":"classes_right-side__MRXEU"};